import { Link } from 'react-router-dom';

interface BreadcrumbProps {
  items: { label: string; href?: string }[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav aria-label="面包屑导航" className="w-full px-4 md:px-6 py-3">
      <ol className="flex items-center gap-2 text-sm text-foreground-500 flex-wrap">
        <li>
          <Link to="/" className="hover:text-primary-600 transition-colors">
            <i className="ri-home-4-line"></i>
          </Link>
        </li>
        {items.map((item, index) => (
          <li key={index} className="flex items-center gap-2">
            <i className="ri-arrow-right-s-line text-xs"></i>
            {item.href ? (
              <Link to={item.href} className="hover:text-primary-600 transition-colors">
                {item.label}
              </Link>
            ) : (
              <span className="text-foreground-800 font-medium">{item.label}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}